import React, { useState } from 'react';
import {  } from 'react-native';
import { showError, showSuccess } from '../toast';
import { api } from '../api';
import { useAuth } from '../AuthContext';
import { Button, Card, Input, Label, Muted, Screen, Title } from '../ui';
import { t } from '../i18n';

export default function OtpScreen({ route, navigation }: any) {
  const { phone, alreadySent } = route.params;
  const { signIn } = useAuth();
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);

  const verify = async () => {
    setLoading(true);
    try {
      const res = await api('/auth/otp/verify', { body: { phone, code } });
      if (res.registered) {
        await signIn(res);
      } else {
        navigation.navigate('Register', {
          registrationToken: res.registrationToken,
          phone,
          invitedAs: res.invitedAs,
          suggestedFirstName: res.suggestedFirstName,
          suggestedLastName: res.suggestedLastName,
        });
      }
    } catch (e: any) {
      showError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Screen>
      <Title>{t('Потвърждение')}</Title>
      <Card>
        {alreadySent ? (
          // Кодът от поканата важи 24 ч — нов SMS не се праща, докато е активен
          <Muted>{t('Кодът ви е в SMS-а с поканата — важи 24 часа от изпращането.')}</Muted>
        ) : (
          <Muted>{t('Изпратихме 6-цифрен код на {phone}.', { phone })}</Muted>
        )}
        <Label>{t('SMS код')}</Label>
        <Input
          placeholder="123456"
          keyboardType="number-pad"
          maxLength={6}
          autoFocus
          value={code}
          onChangeText={setCode}
        />
        <Button title={t('Потвърди')} onPress={verify} disabled={code.length !== 6} loading={loading} />
        <Button
          title={t('Нов код')}
          variant="secondary"
          onPress={async () => {
            try {
              const r = await api<{ alreadySent?: boolean }>('/auth/otp/request', { body: { phone } });
              if (r.alreadySent) showError(t('Вече имате изпратен код — той е в SMS-а с поканата и важи 24 часа.'));
              else showSuccess(t('Изпратихме нов код.'));
            } catch (e: any) {
              showError(e.message);
            }
          }}
        />
      </Card>
    </Screen>
  );
}
